/**
 * Returns the log of number to base 10.
 * @customfunction 
 * @param {number} x Number
 * @returns {number} Log10 of the number.
 */
 function Log10(X) {
  return Math.log10(X);
}

/**
 * Returns a summation of dB values.
 * @customfunction 
 * @param {number[][]} Values Range of values.
 * @returns {number} Returns sum.
 */

 function dBadd(Values){
  let power=0; //power defines the value used for 10.
  let sum=0;   //sum is the recurring addition of 10^ the decibel values.
 
  for (var i = 0 ; i<Values.length ; i++){
    for (var j=0 ; j<Values[i].length ; j++){
      power = Values[i][j]/10;
      sum += Math.pow(10,power)
    }
  }
  const answer = 10*Math.log10(sum);
  return answer
}

/**
 * Returns the difference in dB values.
 * @customfunction 
 * @param {number} Value1 Measured sound level.
 * @param {number} Value2 Background Sound
 * @returns {number} sum of values.
 */

 function dBsub(Value1 , Value2){
  const Ls = 10*Math.log10(Math.pow(10 , Value1 / 10) - Math.pow(10 , Value2 / 10));
  return Ls;
}


/**
 * Returns the average dB value of selected values.
 * @customfunction 
 * @param {number[][]} Values Range of values.
 * @returns {number} Returns the average dB.
 */

 function dBavg(Values){
  let sum=0;  //sum is the recurring addition of 10^ decibel values.
  let power=0; //Used for 10.
  let n=0;   // n is number of values.
  for (var i=0;i<Values.length;i++){
    for (var j=0;j<Values[i].length;j++){
      power=Values[i][j]/10;
      sum+=Math.pow(10,power)
    }
    
  }
  n = i*j;
  const average = 10*Math.log10(sum/n);
  return average;
}


/**
 * Calculates the Rw value from a series of values.
 * @customfunction 
 * @param {number[][]} Levels R values
 * @param {number} StartingBand Stating Octave Band
 * @returns {number} Returns Rw.
 */

 function Rw(Levels , StartingBand){

  const octBands = [100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150]
  const referenceCurve = [33, 36, 39, 42, 45, 48, 51, 52, 53, 54, 55, 56, 56, 56, 56, 56]


  let i, refIndex, X, total, count;
  let found = false;
  count = X = levelCount =0

  if (StartingBand === 0){
    refIndex = 0;
  } else {
    refIndex = octBands.indexOf(StartingBand);
  }

 while (true) {
    total= 0;
    for (i=0; i < Levels.length; i++){
      for (let j = 0; j < Levels[i].length; j++){
        if (Levels[i][j] === null){
          found = true;
        } else{
              //Only if the ref value + increment is > measured is the difference added to total.
              if (referenceCurve[refIndex+i+j] + X > Levels[i][j]) {
                total += referenceCurve[refIndex+i+j] - Levels[i][j] + X;
              }
            }        
      }      
    }
    //round to 1dp
    total = Number(total.toPrecision(10));
    //If total>32, increment is reduced.
    if (total > 32){
      X -= 1;
      if (found){
        return 52+X;
      }
    } else{
      found = true;
      X += 1;
    }
    count+=1
    if(count>1000){
      break;
    }    
  }  
}

/**
 * Calculates the Ctr value from a series of values.
 * @customfunction 
 * @param {number[][]} Levels R values
 * @param {number} StartingBand Starting Octave Band
 * @returns {number} Returns Ctr.
 */

 function Ctr(Levels, startingBand){
   
  const Frequencies = [100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150]
  const oneThirdOctaves = [-20, -20, -18, -16, -15, -14, -13, -12, -11, -9, -8, -9, -10, -11, -13, -15]

  let i, refIndex, total, diff, pow;
  

  if (startingBand === 0){
    refIndex = 0
  } else {
    refIndex = Frequencies.indexOf(startingBand);
  }

  total= 0;
  for( i = 0; i < Levels.length; i++){
    for ( j = 0; j< Levels[i].length; j++){
      diff = oneThirdOctaves[refIndex + i + j] - Levels[i][j];
      pow = diff/10;
      total += Math.pow(10,pow)
    }
  }
  
  let X  = -10 * Math.log10(total)
  let Ctr = X - Rw(Levels, startingBand)   
  return Ctr; 

}

/**
 * Calculates the A-weighting for a particular spectrum.
 * @customfunction 
 * @param {number[][]} Spectrum Spectrum
 * @param {number} StartingFrequency Starting Frequency.
 * @returns {number} Returns dBAt.
 */

 function dBAt(Spectrum , StartingFrequency){
  const AWeightedThirds = [-84.5, -77.8, -70.4, -63.4, -56.7, -50.5, -44.7, -39.4, -34.6, -30.2, -26.2, -22.5, -19.1, -16.1, -13.4, -10.9, -8.6, -6.6, -4.8, -3.2, -1.9, -0.8, -0, 0.6, 1, 1.2, 1.3, 1.2, 1, 0.5, -0.1, -1.1, -2.5, -4.3, -6.6, -9.3]
  const ThirdOctBands = [6.3, 8, 10, 12.5, 16, 20, 25, 31.5, 40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150, 4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000]
  
  let power, total, refIndex, dBAt;
  
  if (StartingFrequency === 0){
    refIndex = 0;
  } else {
    refIndex = ThirdOctBands.indexOf(StartingFrequency);
  }
total = 0;

  for (var i = 0 ; i < Spectrum.length ; i++){
    for (var j=0 ; j < Spectrum[i].length ; j++){
     
      power=(Spectrum[i][j] + AWeightedThirds[i+j+refIndex])/10;
      total+=Math.pow(10,power);

    }

  }
  
  dBAt = 10*Math.log10(total);
  return dBAt;
}

/**
 * Calculates the C-weighting for a particular spectrum.
 * @customfunction 
 * @param {number[][]} Spectrum Spectrum
 * @param {number} StartingFrequency Starting Frequency.
 * @returns {number} Returns dBCt.
 */

 function dBCt(Spectrum , StartingFrequency){
  const CWeightedThirds = [-21.3, -17.7, -14.3, -11.2, -8.5, -6.2, -4.4, -3, -2, -1.3, -0.8, -0.5, -0.3, -0.2, -0.1, 0, 0, 0, 0, 0, 0, 0, 0, 0, -0.1, -0.2, -0.3, -0.5, -0.8, -1.3, -2, -3, -4.4, -6.2, -8.5, -11.2]
  const ThirdOctBands = [6.3, 8, 10, 12.5, 16, 20, 25, 31.5, 40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150, 4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000]
  
  let power, total, thirdOctBandIndex, index, dBCt;
  
  if (StartingFrequency === 0){
    thirdOctBandIndex = 0;
  } else {
    thirdOctBandIndex = ThirdOctBands.indexOf(StartingFrequency);
  }
total = 0;

  for (var i = 0 ; i < Spectrum.length ; i++){
    for (var j=0 ; j < Spectrum[i].length ; j++){
      index = i + j + thirdOctBandIndex
      power = (Spectrum[i][j]+CWeightedThirds[index]) / 10;
      total += Math.pow(10,power);  
    } 
  }
  
  dBCt = 10*Math.log10(total);
  return dBCt;
}

/**
 * Calculates the A-weighting adjustment for a particular spectrum.
 * @customfunction 
 * @param {number[][]} Spectrum Spectrum
 * @param {number} StartingFrequency Starting Frequency.
 * @returns {number} Returns dBA.
 */

 function dBA(Spectrum , StartingFrequency){
  const AWeightedOcts = [-56.7, -39.4, -26.2, -16.1, -8.6, -3.2, 0, 1.2, 1, -1.1, -6.6]
  const octBands = [16, 31.5, 63, 125, 250, 500, 1000, 2000, 4000, 8000, 16000]
  let power, total, octBandsIndex, index, dBA;
  
  if (StartingFrequency === 0){
    octBandsIndex = 0;
  } else {
    octBandsIndex = octBands.indexOf(StartingFrequency);
  }
  total = 0;

  for (var i = 0 ; i < Spectrum.length ; i++){
    for (var j=0 ; j < Spectrum[i].length ; j++){
      index = i + j + octBandsIndex;
         power = (Spectrum[i][j]+AWeightedOcts[index]) / 10;
          total += Math.pow(10,power);  
        } 
  }

   
  dBA = 10*Math.log10(total);
  return dBA;
}

/**
 * Calculates the Rwoct value from a series of values.
 * @customfunction 
 * @param {number[][]} Levels R values
 * @returns {number} Returns Rwoct.
 */

 function Rwoct(Levels){

  const referenceCurve = [36, 45, 52, 55, 56]

  let i, j, X, total, count;
  let found = false;
  count = X = 0


 while (true) {
    total= 0;

    for (i=0; i < Levels.length; i++){
      for (j = 0; j < Levels[i].length; j++){

        if (Levels[i][j] === null){
          found = true;
        } else{
              //Only if the ref value + increment is > measured is the difference added to total.
              if (referenceCurve[i+j] + X > Levels[i][j]) {
                total += referenceCurve[i+j] - Levels[i][j] + X;
              }
        }     
      }
    }
    //round to 1dp
    total = Number(total.toPrecision(10));
    //If total>32, increment is reduced.
    if (total > 10){
      X -= 1;
      if (found){
        return 52+X;
      }
    } else{
      found = true;
      X += 1;
    }
    count+=1
    if(count>1000){
      break;
    } 
  }  
}

/**
 * Calculates the NR value from a series of values.
 * @customfunction 
 * @param {number[][]} Spectrum spectrum of values.
 * @param {number} StartingFrequency Starting Frequency
 * @returns {number} Returns NR.
 */

function NR(Spectrum, StartingFrequency){

  const a = [55.4, 35.4, 22, 12, 4.2, 0, -3.5, -6.1, -8]
  const b = [0.681, 0.79, 0.87, 0.93, 0.98, 1, 1.015, 1.025, 1.03]
  const OctaveBand = [31.5, 63, 125, 250, 500, 1000, 2000, 4000, 8000]
  
  let i, j, total,criteria, octBandIndex;

  if (StartingFrequency === 0){
    octBandIndex = 0;
  } else {
    octBandIndex = OctaveBand.indexOf(StartingFrequency);
  }

  total=0;
  
     for (i = 0 ; i < Spectrum.length ; i++){
     for (j = 0 ; j < Spectrum[i].length ; j++){        
          
          criteria=(Spectrum[i][j]-(a[i+j+octBandIndex]))/(b[i+j+octBandIndex])          
           if (criteria>total){
            total=criteria;
            }          
       }
     } 
  return total.toPrecision(2);
}


/**
 * Calculates the NRs value of a curve.
 * @customfunction 
 * @param {number} Curve Specifies the NR curve.
 * @param {number} StartingFrequency Starting Frequency
 * @returns {number} Returns NRs.
 */

function NRs(Curve, StartingFrequency){

  const a = [55.4, 35.4, 22, 12, 4.2, 0, -3.5, -6.1, -8]
  const b = [0.681, 0.79, 0.87, 0.93, 0.98, 1, 1.015, 1.025, 1.03]
  const OctaveBand = [31.5, 63, 125, 250, 500, 1000, 2000, 4000, 8000]

  let index, NRs;

  if (StartingFrequency === 0){
    index = 0;
  } else {
    index = OctaveBand.indexOf(StartingFrequency);
  }

  NRs = a[index]+ b[index]*Curve;
  return NRs.toPrecision(2);
  
}
CustomFunctions.associate("LOG10", Log10);
CustomFunctions.associate("DBADD", dBadd);
CustomFunctions.associate("DBSUB", dBsub);
CustomFunctions.associate("DBAVG", dBavg);
CustomFunctions.associate("RW", Rw);
CustomFunctions.associate("CTR", Ctr);
CustomFunctions.associate("DBAT", dBAt);
CustomFunctions.associate("DBCT", dBCt);
CustomFunctions.associate("DBA", dBA);
CustomFunctions.associate("RWOCT", Rwoct);
CustomFunctions.associate("NR", NR);
CustomFunctions.associate("NRS", NRs);